export const userMixin = {
  computed: {
    // It is used to allow the user to view order and parent item prices
    allowViewingParentPrices() {
      if (!this.$auth.user) return true
      return this.$auth.user.permissions.includes('WEBPOS_PAYMENTS:WEBPOS_SPEC_VIEW_PRICES')
    },

    // It is used to allow the user to edit or delete their own notes
    allowEditingNotes(){
      if (!this.$auth.user) return true

      return this.$auth.user.permissions.includes('WEBPOS_CUSTOMER_DETAIL:WEBPOS_SPEC_EDIT_NOTES')
    },

    // It is used to allow the user to edit sales commissions
    allowEditingSalesCommissions(){
      if (!this.$auth.user) return true
      return this.$auth.user.permissions.includes('WEBPOS_CUSTOM_ORDER:WEBPOS_SPEC_EDIT_SALES_COMMISSIONS')
    },

    // It is used to allow the user to access sales commissions
    allowAccessToSalesCommissions(){
      if (!this.$auth.user) return true
      return this.$auth.user.permissions.includes('WEBPOS_CUSTOM_ORDER:WEBPOS_SPEC_ALLOW_ACCESS_TO_SALES_COMMISSIONS')
    },

    // It is used to allow the user to view subitem prices
    allowViewingSubitemPrices() {
      if (!this.$auth.user) return true

      return this.$auth.user.permissions.includes('WEBPOS_PAYMENTS:WEBPOS_SPEC_VIEW_SUBITEM_PRICES')
    },

    // It is used to allow the user to view parent item prices when the order is not new
    allowViewingParentPriceWhenNotNew() {
      if (!this.$auth.user) return true

      return this.$auth.user.permissions.includes('WEBPOS_PAYMENTS:WEBPOS_SPEC_VIEW_PARENT_ITEM_PRICES_NOT_NEW_STATUS')
    },

    allowViewingPrices() {
      return this.allowViewingParentPrices || this.allowViewingParentPriceWhenNotNew
    },

    // It is used to allow the user to edit catalog orders
    allowEditingCatalogOrders() {
      return this.$auth.user.permissions.includes('WEBPOS_ORDERS:WEBPOS_CATALOG_ORDER_EDIT')
    },

    allowOverridingDocumentSignature(){
      if (!this.$auth.user) return true
      return this.$auth.user.permissions.includes('WEBPOS_ORDERS:WEBPOS_OVERRIDE_DOCUMENT_SIGNATURE')
    },

    allowEditingOutgoingConsignments(){
      if (!this.$auth.user) return true
      return this.$auth.user.permissions.includes('WEBPOS_OUTGOING_CONSIGNMENTS:WEBPOS_OUTGOING_CONSIGNMENT_EDIT')
    },

    // It is used to allow the user to override the discount threshold
    allowOverridingDiscountThreshold(){
      if (!this.$auth.user) return true
      return this.$auth.user.permissions.includes('WEBPOS_CUSTOM_ORDER:WEBPOS_SPEC_ENABLE_DISCOUNT_OVERRIDE')
    },

    // It is used to allow subitem handling on CO
    allowSubitemHandlingOnCustomOrder(){
      if (!this.$auth.user) return true
      return this.$auth.user.permissions.includes('WEBPOS_CUSTOM_ORDER:WEBPOS_SPEC_ALLOW_SUBITEM_HANDLING_IN_CO')
    },

    // It is used to allow discount field view on CO
    allowDiscountFieldViewOnCustomOrder(){
      if (!this.$auth.user) return true
      return this.$auth.user.permissions.includes('WEBPOS_CUSTOM_ORDER:WEBPOS_SPEC_ALLOW_DISCOUNT_FIELD_VIEW')
    },

    // It is used to override component-based prices
    allowOverridingComponentBasedPrices() {
      return this.$auth.user.permissions.includes('WEBPOS_CUSTOM_ORDER:WEBPOS_SPEC_ALLOW_OVERRIDING_COMPONENT_BASED_PRICES')
    },

    // It is used to show/hide discount/markup on new sale
    showDiscountMarkupOnNewSale() {
      if (!this.$auth.user) return true
      return this.$auth.user.permissions.includes('WEBPOS_NEWSALE:WEBPOS_SPEC_SHOW_DISCOUNT_MARKUP_ON_NEW_SALE')
    },

    // It is used to allow catalog order deletion
    allowCatalogOrderDeletion() {
      if (!this.$auth.user) return true
      return this.$auth.user.permissions.includes('WEBPOS_ORDERS:WEBPOS_SPEC_ENABLE_CATALOG_ORDER_DELETION')
    },
  }
}
